import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {INewSalaryExportState, initialNewSalaryExportState} from '@app/core/store/state/new-salary-export.state';
import {ENewSalaryExportActions, NewSalaryExportActions} from '@app/core/store/actions/new-salary-export.actions';

export const newSalaryExportReducers = (
	state = initialNewSalaryExportState,
	action: NewSalaryExportActions | ErrorActions,
): INewSalaryExportState => {
	switch (action.type) {
		case ENewSalaryExportActions.SetSelectedTimePeriod: {
			return {
				...state,
				selectedTimePeriod: action.timePeriod,
			};
		}
		case ENewSalaryExportActions.GetDepartments: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ENewSalaryExportActions.GetDepartmentsSuccess: {
			return {
				...state,
				isLoading: false,
				availableDepartments: action.departments.filter(department => {
					const selectedDepartmentIds = state.selectedDepartmentsWithUsers.map(selectedDepartment => selectedDepartment.department.id);
					return selectedDepartmentIds.indexOf(department.id) === -1;
				}),
			};
		}
		case ENewSalaryExportActions.GetGroups: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ENewSalaryExportActions.GetGroupsSuccess: {
			return {
				...state,
				isLoading: false,
				availableGroups: action.groups,
			};
		}
		case ENewSalaryExportActions.SetSelectedDepartment: {
			return {
				...state,
				selectedDepartment: action.department,
			};
		}
		case ENewSalaryExportActions.SetSelectedUsers: {
			return {
				...state,
				selectedUsers: action.users,
			};
		}
		case ENewSalaryExportActions.AddUserToSelectedUsers: {
			return {
				...state,
				selectedUsers: [action.user, ...state.selectedUsers]
			};
		}
		case ENewSalaryExportActions.RemoveUserFromSelectedUsers: {
			return {
				...state,
				selectedUsers: state.selectedUsers.filter(u => u.data.id !== action.user.data.id),
			};
		}
		case ENewSalaryExportActions.AddDepartmentWithUsers: {
			return {
				...state,
				selectedDepartmentsWithUsers: [...state.selectedDepartmentsWithUsers, action.departmentWithUsers],
			};
		}
		case ENewSalaryExportActions.RemoveDepartmentWithUsers: {
			return {
				...state,
				selectedDepartmentsWithUsers: state.selectedDepartmentsWithUsers
					.filter(d => d.department.id !== action.departmentWithUsers.department.id),
			};
		}
		case ENewSalaryExportActions.RemoveDepartment: {
			return {
				...state,
				availableDepartments: state.availableDepartments.filter(d => d.id !== action.department.id),
			};
		}
		case ENewSalaryExportActions.AddDepartment: {
			return {
				...state,
				availableDepartments: [...state.availableDepartments, action.department],
			};
		}
		case ENewSalaryExportActions.AddIntegration: {
			return {
				...state,
				savedIntegrations: [...state.savedIntegrations, action.integration],
				availableIntegrations: state.availableIntegrations.filter(i => i.id !== action.integration.id),
			};
		}
		case ENewSalaryExportActions.RemoveIntegration: {
			return {
				...state,
				savedIntegrations: state.savedIntegrations.filter(i => i.id !== action.integration.id),
				availableIntegrations: [...state.availableIntegrations.filter(i => i.id !== action.integration.id), action.integration]
			};
		}
		case ENewSalaryExportActions.GetShiftCountSuccess: {
			return {
				...state,
				shiftCount: action.shiftCount,
			};
		}
		case ENewSalaryExportActions.GetIntegrations: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ENewSalaryExportActions.GetIntegrationsSuccess: {
			return {
				...state,
				isLoading: false,
				availableIntegrations: action.integrations,
			};
		}
		case ENewSalaryExportActions.SetSelectedIntegration: {
			return {
				...state,
				selectedIntegration: action.integration,
			};
		}
		case ENewSalaryExportActions.FinishExport: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ENewSalaryExportActions.FinishExportSuccess: {
			return {
				...state,
				isLoading: false,
			};
		}
		case ENewSalaryExportActions.GetShiftCalculations: {
			return {
				...state,
				isLoadingCalculation: true,
			};
		}
		case ENewSalaryExportActions.GetShiftCalculationsSuccess: {
			return {
				...state,
				isLoadingCalculation: false,
				shiftCalculations: action.calculations.calculations,
				paymentPeriods: action.calculations.payment_periods,
			};
		}
		case ENewSalaryExportActions.GetShiftCalculation: {
			return {
				...state,
				isLoadingCalculation: true,
			};
		}
		case ENewSalaryExportActions.GetShiftCalculationSuccess: {
			return {
				...state,
				isLoadingCalculation: false,
				shiftCalculation: action.calculation.calculation,
				paymentPeriods: action.calculation.payment_periods,
			};
		}
		case ENewSalaryExportActions.SetSelectedYear: {
			return {
				...state,
				selectedYear: action.year,
			};
		}
		case ENewSalaryExportActions.SetSelectedMonth: {
			return {
				...state,
				selectedMonth: action.month,
			};
		}
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
				isLoadingCalculation: false,
			};
		}
		default: {
			return state;
		}
	}
};

